"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _chainFunction = _interopRequireDefault(require("chain-function"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _constants = require("../utils/constants");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Title = _interopRequireDefault(require("../Title/Title"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _bar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/bar.css") : void 0);

var _dialog = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/dialog.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _bar.default), _dialog.default));
var barClassnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _bar.default);
var isUsingCssModules = _dialog.default && (0, _keys.default)(_dialog.default).length > 0;
/** A **Dialog** is a container generally displayed in response to an action. It is used for short forms,
 * confirmation messages or to display contextual information that does not require a page.\n\nTo
 * display the **Dialog** dialog, pass a boolean value to the \`show\` property of the component. It is
 * recommended to store this value as a state property in the parent control or application.
 * This is used to present information to the user when the **MessageStrip** component doesn’t fit all the information. */

var _ref = /*#__PURE__*/_react.default.createElement("span", {
  "data-autofocus": true,
  tabIndex: "-1"
});

var Dialog = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dialog, _Component);

  var _super = _createSuper(Dialog);

  function Dialog() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.bodyElm = document.querySelector('body');

    _this.handleCloseClick = function (e) {
      _this.props.onClose(e);
    };

    _this.handleKeyPress = function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        _this.handleCloseClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Dialog, [{
    key: "componentDidMount",
    // add event listener for escape key
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyPress, false);
    } // remove event listener for escape key

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _context2,
          _classnames3,
          _context3,
          _this2 = this;

      var _this$props = this.props,
          actions = _this$props.actions,
          backdropClassName = _this$props.backdropClassName,
          bodyProps = _this$props.bodyProps,
          children = _this$props.children,
          className = _this$props.className,
          cssNamespace = _this$props.cssNamespace,
          contentProps = _this$props.contentProps,
          headerProps = _this$props.headerProps,
          headingLevel = _this$props.headingLevel,
          headingStyle = _this$props.headingStyle,
          header = _this$props.header,
          footerProps = _this$props.footerProps,
          onClose = _this$props.onClose,
          show = _this$props.show,
          size = _this$props.size,
          subheader = _this$props.subheader,
          titleProps = _this$props.titleProps,
          title = _this$props.title,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["actions", "backdropClassName", "bodyProps", "children", "className", "cssNamespace", "contentProps", "headerProps", "headingLevel", "headingStyle", "header", "footerProps", "onClose", "show", "size", "subheader", "titleProps", "title"]);
      var dialogClasses = classnames("".concat(cssNamespace, "-dialog"), (0, _defineProperty3.default)({}, "".concat(cssNamespace, "-dialog--active"), show), className);
      var contentClasses = classnames("".concat(cssNamespace, "-dialog__content"), (0, _defineProperty3.default)({}, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-dialog__content--")).call(_context2, size), size));
      var headerClasses = classnames("".concat(cssNamespace, "-dialog__header"), "".concat(cssNamespace, "-bar"), (_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, "".concat(cssNamespace, "-bar--header-with-subheader"), subheader), (0, _defineProperty3.default)(_classnames3, barClassnames("".concat(cssNamespace, "-bar")), isUsingCssModules), _classnames3), className);

      if (!show) {
        return null;
      }

      return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_reactFocusLock.default, {
        as: "div",
        className: backdropClassName,
        lockProps: _objectSpread({}, rest)
      }, _ref, /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": title,
        "aria-modal": "true",
        className: dialogClasses,
        role: "dialog"
      }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, contentProps, {
        className: contentClasses,
        role: "document"
      }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, headerProps, {
        className: headerClasses
      }), header && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-bar__element"))
      }, header), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-bar__element"))
      }, /*#__PURE__*/_react.default.createElement(_Title.default, (0, _extends2.default)({}, titleProps, {
        level: headingLevel,
        levelStyle: headingStyle
      }), title)), subheader && /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-dialog__subheader"), "".concat(cssNamespace, "-bar"), "".concat(cssNamespace, "-bar--subheader"), (0, _defineProperty3.default)({}, barClassnames("".concat(cssNamespace, "-bar")), isUsingCssModules))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-bar__left"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-bar__element"))
      }, subheader)))), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, bodyProps, {
        className: classnames("".concat(cssNamespace, "-dialog__body"))
      }), children), /*#__PURE__*/_react.default.createElement("footer", (0, _extends2.default)({}, footerProps, {
        className: classnames("".concat(cssNamespace, "-dialog__footer"), "".concat(cssNamespace, "-bar"), "".concat(cssNamespace, "-bar--footer"), (0, _defineProperty3.default)({}, barClassnames("".concat(cssNamespace, "-bar")), isUsingCssModules))
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-bar__right"))
      }, (0, _map.default)(_context3 = _react.default.Children.toArray(actions)).call(_context3, function (child, index) {
        var _child$props;

        return /*#__PURE__*/_react.default.createElement("div", {
          className: classnames("".concat(cssNamespace, "-bar__element")),
          key: index
        }, /*#__PURE__*/_react.default.cloneElement(child, {
          className: classnames("".concat(cssNamespace, "-dialog__decisive-button")),
          onClick: (0, _chainFunction.default)(_this2.handleCloseClick, (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.onClick)
        }));
      })))))), this.bodyElm);
    }
  }]);
  return Dialog;
}(_react.Component);

Dialog.displayName = 'Dialog';
process.env.NODE_ENV !== "production" ? Dialog.propTypes = {
  /** Node(s) to render within the footer of the dialog */
  actions: _propTypes.default.arrayOf(_propTypes.default.node).isRequired,

  /** Localized text for the heading */
  title: _propTypes.default.string.isRequired,

  /** CSS class(es) to add to the dialog backdrop */
  backdropClassName: _propTypes.default.string,

  /** Additional props to be spread to the body section of the dialog */
  bodyProps: _propTypes.default.object,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Additional props to be spread to the content section of the dialog */
  contentProps: _propTypes.default.object,

  /** Additional props to be spread to the footer of the dialog */
  footerProps: _propTypes.default.object,

  /** Text for the components header */
  header: _propTypes.default.string,

  /** Additional props to be spread to the header of the dialog */
  headerProps: _propTypes.default.object,

  /** Heading level. `<h1>` is reserved for the page title. It should not appear in components */
  headingLevel: _CustomPropTypes.default.range(2, 6),

  /** Heading style, if it should be different from the default style for the Dialog. */
  headingStyle: _CustomPropTypes.default.range(2, 6),

  /** Set to **true** to make the dialog visible */
  show: _propTypes.default.bool,

  /** By default dialog body has no horizontal paddings. Add a size to modify the padding: 's', 'm', 'l', 'xl' */
  size: _propTypes.default.oneOf(_constants.DIALOG_SIZES),

  /** Text for the components subheader */
  subheader: _propTypes.default.string,

  /**Additional props to be spread to the title\'s heading element */
  titleProps: _propTypes.default.object,

  /** Callback function; triggered when dialog closes either due to `Escape` keydown or any of the actions' `onClick`.
   * `onClose` is executed BEFORE any of the actions' `onClick` handler.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
   */
  onClose: _propTypes.default.func
} : void 0;
Dialog.defaultProps = {
  headingLevel: 3,
  headingStyle: 5,
  size: 'l',
  onClose: function onClose() {}
};

var _default = (0, _withStyles.default)(Dialog);

exports.default = _default;